import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  SOCIAL_MEDIA_MESSAGES_CLEAR,
  SOCIAL_MEDIA_MESSAGES_FETCH_MESSAGES,
} from '../../actions/actionTypes';

const messages = fetchReducerGenerator(
  SOCIAL_MEDIA_MESSAGES_CLEAR,
  SOCIAL_MEDIA_MESSAGES_FETCH_MESSAGES
);

export default messages;
